'use client';

import { useTranslations } from 'next-intl';

import * as HeroSection from '@/components/hero-section';
import SampleHero from '@images/sample-hero.webp';

export default function Hero() {
  const t = useTranslations('Sample.heroSection');

  const menus = t('menu').split('||');
  const title = t('title');

  return (
    <HeroSection.Section>
      <HeroSection.Oval className="overflow-hidden bg-[#040435] md:w-[48%] lg:w-[55%]">
        <HeroSection.Image
          src={SampleHero}
          alt="sample"
          className="bottom-0 right-0 top-auto h-auto max-h-none w-[450px] min-w-0 max-w-none md:w-[780px] md:translate-x-[calc(550px-30vw)] 2xl:translate-x-0"
          sizes="(max-width: 768px) 450px, 780px"
          priority
        />
      </HeroSection.Oval>

      <HeroSection.TitleBox>
        <HeroSection.Menu menus={menus} size="lg" className="md:mt-0" />
        <HeroSection.Title title={title} className="md:leading-[72px]" />
      </HeroSection.TitleBox>
    </HeroSection.Section>
  );
}
